import * as React from "react"

import { Alert } from "@coval/ui"

import type { RunRowLike } from "@/types/RunRow"

interface ScopedSimulationsBannerProps {
  runRows: RunRowLike[]
  selectedSimulationOutputIds: string[]
  className?: string
}

/**
 * Announces that the metric cards are scoped to the current selection. Renders
 * nothing when no simulations are selected so callers can drop it in-place.
 */
export const ScopedSimulationsBanner: React.FC<
  ScopedSimulationsBannerProps
> = ({ runRows, selectedSimulationOutputIds, className }) => {
  if (selectedSimulationOutputIds.length === 0) {
    return null
  }

  const ids = new Set(selectedSimulationOutputIds)
  const scopedCount = runRows.filter(
    (row) =>
      typeof row.simulation_output_id === "string" &&
      ids.has(row.simulation_output_id),
  ).length

  return (
    <Alert
      variant="info"
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className={className}
    >
      Scoped to {scopedCount} of {runRows.length} simulations
    </Alert>
  )
}
